import { Component, input } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Observable, of } from 'rxjs';
import { Breadcrumb } from '../breadcrumb/breadcrumb.component';

@Component({
    selector: 'lokos-page-header',
    standalone: false,
    templateUrl: './page-header.component.html',
    styleUrl: './page-header.component.scss'
})
export class PageHeaderComponent {
    breadcrumbs = input.required<Breadcrumb[]>();
    label = input<string>('dashboard');

    queryParams: Observable<Params> = of({});

    constructor (private activatedRoute: ActivatedRoute) {
        this.queryParams = this.activatedRoute.queryParams;
    }
}
